import React from 'react';
import { withRouter } from 'react-router-dom';

import LoginController from './LoginController';

export default function AuthController(Component, staticProps = {}) {
  class AuthenticatedComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {checked: false};
    }

    componentWillMount() {
      this.checkAuth();
    }

    checkAuth() {
      const that = this;
      fetch('/api/auth', {credentials: 'same-origin', method: 'GET'}).then((res) => {
        if (res.status === 200) {
          that.setState({checked: true, success: true});
        } else {
          that.setState({checked: true, success: false});
        }
      });
    }

    render() {
      if (this.state.checked && this.state.success) {
        return <Component {...this.props} {...staticProps} />;
      } else if (this.state.checked) {
        return <LoginController />
      } else {
        return <div>Checking auth</div>;
      }
    }
  }

  return withRouter(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/controllers/AuthController.js